"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaPastLiveCardDefaultProps = exports.DomestikaPastLiveCardPropTypes = exports.DomestikaPastLiveCard = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Card = require("../../atoms/Card");

var _DomestikaLiveCardInfo = require("../../atoms/DomestikaLiveCardInfo");

var _DomestikaLiveCardSkeleton = require("../../atoms/DomestikaLiveCardSkeleton");

var _DomestikaLiveTag = require("../../atoms/DomestikaLiveTag");

var _Icon = require("../../atoms/Icon");

var _Icons = require("../../atoms/Icons");

var _Layout = require("../../atoms/Layout");

var _When = _interopRequireDefault(require("../../utils/When"));

var _withTooltip = require("../../HOC/withTooltip");

var _hooks = require("../../utils/hooks");

var _validate = require("./validate");

var StyledCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "DomestikaPastLiveCard__StyledCard",
  componentId: "sc-88b9yn-0"
})((0, _css.default)({
  padding: '0',
  cursor: 'pointer'
}), (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      cursor: 'default'
    }
  }
}));
var StyledIconWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaPastLiveCard__StyledIconWrapper",
  componentId: "sc-88b9yn-1"
})({
  cursor: 'default',
  padding: '6px'
}, (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: '50%'
    }
  }
}));
var StyledIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DomestikaPastLiveCard__StyledIcon",
  componentId: "sc-88b9yn-2"
})({
  fontSize: '20px',
  lineHeight: '20px'
});

var LockIcon = function LockIcon(props) {
  return _react.default.createElement(StyledIconWrapper, props, _react.default.createElement(StyledIcon, {
    size: "medium"
  }, _react.default.createElement(_Icons.Lock, null)));
};

var StudentIcon = function StudentIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "quandog",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, {
    size: "small",
    color: "coco"
  }, _react.default.createElement(_Icons.Cap, null)));
};

var DomestikaPastLiveCard = function DomestikaPastLiveCard(_ref) {
  var streamers = _ref.streamers,
      liveInfo = _ref.liveInfo,
      loading = _ref.loading,
      liveNow = _ref.liveNow,
      locked = _ref.locked,
      lockedTooltip = _ref.lockedTooltip,
      student = _ref.student,
      studentTooltip = _ref.studentTooltip,
      onClick = _ref.onClick,
      observerRootElement = _ref.observerRootElement,
      lazyLoading = _ref.lazyLoading,
      width = _ref.width,
      height = _ref.height,
      props = (0, _objectWithoutProperties2.default)(_ref, ["streamers", "liveInfo", "loading", "liveNow", "locked", "lockedTooltip", "student", "studentTooltip", "onClick", "observerRootElement", "lazyLoading", "width", "height"]);

  if (!loading) {
    (0, _validate.validate)({
      streamers: streamers,
      liveInfo: liveInfo,
      onClick: onClick
    });
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showUpperIcons = _useState2[0],
      setShowUpperIcons = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      upperIconsElements = _useState4[0],
      setUpperIconsElements = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      iconsWrapperMargin = _useState6[0],
      setIconsWrapperMargin = _useState6[1];

  var _useLazyLoadElement = (0, _hooks.useLazyLoadElement)({
    lazyLoading: lazyLoading,
    rootElement: observerRootElement,
    rootMargin: '0px'
  }),
      isElementVisible = _useLazyLoadElement.isElementVisible,
      getElementRef = _useLazyLoadElement.getElementRef;

  var getIconsWrapperRef = function getIconsWrapperRef(node) {
    if (node !== null) {
      var nodeHeight = node.getBoundingClientRect().height;
      setIconsWrapperMargin(nodeHeight * -1);
    }
  };

  var getIconMargin = function getIconMargin(index) {
    var iconsListLastElement = upperIconsElements.length - 1;
    return index < iconsListLastElement ? 3 : 0;
  };

  var isLoadingState = function isLoadingState() {
    return loading || !isElementVisible;
  };

  (0, _react.useEffect)(function () {
    setShowUpperIcons(liveNow || locked || student);
    var elements = [];

    if (liveNow) {
      elements.push(function () {
        return _react.default.createElement(_DomestikaLiveTag.DomestikaLiveTag, null);
      });
    }

    if (locked) {
      elements.push((0, _withTooltip.WithTooltip)(LockIcon, {
        position: 'left',
        message: lockedTooltip,
        id: 'dmstk-past-live-lock-icon-tooltip'
      }));
    }

    if (student) {
      elements.push((0, _withTooltip.WithTooltip)(StudentIcon, {
        position: 'left',
        message: studentTooltip,
        id: 'dmstk-past-live-student-icon-tooltip'
      }));
    }

    setUpperIconsElements(elements);
  }, [liveNow, locked, student]);
  return _react.default.createElement("div", {
    ref: getElementRef
  }, _react.default.createElement(StyledCard, (0, _extends2.default)({
    onClick: onClick,
    boxShadow: "small",
    borderRadius: 3,
    width: width,
    height: height,
    loading: isLoadingState() ? 'true' : 'false'
  }, props), _react.default.createElement(_When.default, {
    condition: !!isLoadingState()
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      padding: [4, 5],
      paddingTop: 5
    }, _react.default.createElement(_DomestikaLiveCardSkeleton.DomestikaLiveCardSkeleton, {
      type: "complete"
    }));
  }), _react.default.createElement(_When.default, {
    condition: !isLoadingState()
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      flexDirection: "column"
    }, _react.default.createElement(_When.default, {
      condition: showUpperIcons
    }, function () {
      return _react.default.createElement(_Layout.Flex, {
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: [2, 4],
        paddingTop: [2, 4],
        ref: getIconsWrapperRef,
        style: {
          zIndex: 20
        }
      }, upperIconsElements === null || upperIconsElements === void 0 ? void 0 : upperIconsElements.map(function (element, index) {
        return _react.default.createElement(_Layout.Box, {
          key: "dmskt-past-live-card-icon-".concat(index + 1),
          marginRight: getIconMargin(index)
        }, element());
      }));
    }), _react.default.createElement(_Layout.Flex, {
      padding: [4, 5],
      paddingTop: 5,
      marginTop: "".concat(iconsWrapperMargin, "px"),
      style: {
        zIndex: 10
      }
    }, _react.default.createElement(_DomestikaLiveCardInfo.DomestikaLiveCardInfo, {
      liveInfo: liveInfo,
      streamers: streamers,
      fontColor: "dark",
      size: "tiny"
    })));
  })));
};

exports.DomestikaPastLiveCard = DomestikaPastLiveCard;
var DomestikaPastLiveCardPropTypes = {
  streamers: _propTypes.default.arrayOf(_propTypes.default.shape({
    avatar: _propTypes.default.string,
    name: _propTypes.default.string
  })),
  liveInfo: _propTypes.default.shape({
    scheduledAt: _propTypes.default.string,
    language: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  loading: _propTypes.default.bool,
  liveNow: _propTypes.default.bool,
  locked: _propTypes.default.bool,
  lockedTooltip: _propTypes.default.string,
  student: _propTypes.default.bool,
  studentTooltip: _propTypes.default.string,
  onClick: _propTypes.default.func,
  lazyLoading: _propTypes.default.bool,
  observerRootElement: _propTypes.default.node,
  width: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string])
};
exports.DomestikaPastLiveCardPropTypes = DomestikaPastLiveCardPropTypes;
var DomestikaPastLiveCardDefaultProps = {
  streamers: null,
  liveInfo: null,
  loading: false,
  liveNow: false,
  locked: false,
  lockedTooltip: '',
  student: false,
  studentTooltip: '',
  onClick: null,
  lazyLoading: false,
  observerRootElement: null,
  width: ['100%', '412px', '454px', '380px'],
  height: ['140px', '148px', '148px', '148px']
};
exports.DomestikaPastLiveCardDefaultProps = DomestikaPastLiveCardDefaultProps;
DomestikaPastLiveCard.defaultProps = DomestikaPastLiveCardDefaultProps;